import { render, staticRenderFns } from "./wechat_callback.vue?vue&type=template&id=1f6b3b76&scoped=true&"
import script from "./wechat_callback.vue?vue&type=script&lang=js&"
export * from "./wechat_callback.vue?vue&type=script&lang=js&"
import style0 from "./wechat_callback.vue?vue&type=style&index=0&id=1f6b3b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b3b76",
  null
  
)

export default component.exports